/**
 * Utilitários para formatação e manipulação de músicas
 */
import { formatStorageUrl } from '@/lib/supabase';
import { Song } from '@/types/player';

/**
 * Formata uma música do banco de dados para o formato usado no player
 * @param song - Música do banco de dados
 * @returns Música formatada
 */
export function formatSong(song: any): Song {
  const formatted: Song = {
    ...song,
    id: song.id?.toString() || String(song.id),
    audio_url: formatStorageUrl(song.audio_url),
    capa_url: formatStorageUrl(song.capa_url),
    cover_url: formatStorageUrl(song.capa_url),
    capitulo: String(song.capitulo || ''),
    // Usa o campo descricao do banco (sempre preenchido no formato "Livro Capítulo:Versículos")
    // Fallback apenas para músicas antigas que possam não ter descricao
    descricao: song.descricao || `${song.livro} ${song.capitulo}${song.versiculos ? `:${song.versiculos}` : ''}`,
    titulo: song.descricao || song.titulo || `${song.livro} ${song.capitulo}${song.versiculos ? `:${song.versiculos}` : ''}`,
    // Garante que is_free sempre tenha um valor (padrão: true se não especificado)
    is_free: song.is_free !== undefined ? song.is_free : true
  };
  
  return formatted;
}

/**
 * Formata múltiplas músicas
 * @param songs - Array de músicas do banco de dados
 * @returns Array de músicas formatadas
 */
export function formatSongs(songs: any[]): Song[] {
  return songs.map(song => formatSong(song));
}

